//require('file-loader?name=[name].[ext]!./index.html');
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
  <Fragment>
    <App />
  </Fragment>
  ,
  document.getElementById('root')
);

